import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
import ContactForm from './ContactForm';
import Link from './Link';
import styles from './Contact.module.css';
import { localPhoneIcon, mobilePhoneIcon, mailIcon } from '../utils/icons';

const Contact = ({
  contactFormConfig,
  dataprivacy,
  dataprocessing,
  company: {
    coordinates: { lat, lon },
    address,
    name,
    ceo,
    image: {
      file: { url },
    },
    mail,
    mobile,
    phone,
  },
  apiKey,
}) => {
  return (
    <div className={styles.contact}>
      <div className={styles.head}>
        <Link name="Kontakt" tag="h4" />
        <h3 className={styles.subheader}>{name.toUpperCase()}</h3>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.card}>
          <span className={styles.content}>
            <List dense disablePadding>
              <ListItem disableGutters>
                <ListItemText
                  classes={{ root: `${styles.root} ${styles.header}`, primary: styles.name, secondary: styles.secondary }}
                  primary={ceo}
                  secondary="Geschäftsführer"
                />
              </ListItem>
              <Divider />
              <ListItem disableGutters>
                <Avatar className={styles.avatar}>{localPhoneIcon}</Avatar>
                <ListItemText
                  classes={{ primary: styles.primary }}
                  primary={phone}
                  onClick={() => (location.href = `tel:+${phone.replace(/\D/g, '')}`).replace('0', '')}
                />
              </ListItem>
              <ListItem disableGutters>
                <Avatar className={styles.avatar}>{mobilePhoneIcon}</Avatar>
                <ListItemText
                  classes={{ primary: styles.primary }}
                  primary={mobile}
                  onClick={() => (location.href = `tel:+${mobile.replace(/\D/g, '')}`).replace('0', '')}
                />
              </ListItem>
              <ListItem disableGutters>
                <Avatar className={styles.avatar}>{mailIcon}</Avatar>
                <ListItemText classes={{ primary: styles.primary }} primary={mail} onClick={() => (location.href = `mailto:${mail}`)} />
              </ListItem>
            </List>
            <List dense disablePadding>
              <ListItem disableGutters classes={{ root: styles.imgAvatarRoot }}>
                <div>
                  <img src={url} className={styles.imgAvatar} />
                </div>
              </ListItem>
            </List>
          </span>
        </div>
        <div className={styles.card}>
          <ContactForm receiver={contactFormConfig.endpoint.receiver} endpoint={contactFormConfig.endpoint.url} dataprivacy={dataprivacy} dataprocessing={dataprocessing} />
        </div>
      </div>
    </div>
  );
};

Contact.propTypes = {
  contactFormConfig: PropTypes.shape({
    domain: PropTypes.string,
    endpoint: PropTypes.shape({
      url: PropTypes.string,
      receiver: PropTypes.string,
    }),
  }).isRequired,
  dataprivacy: PropTypes.array.isRequired,
  dataprocessing: PropTypes.array.isRequired,
  company: PropTypes.shape({
    addressFields: PropTypes.arrayOf(PropTypes.string),
    address: PropTypes.string,
    name: PropTypes.string,
    ceo: PropTypes.string,
    mobile: PropTypes.string,
    mail: PropTypes.string,
    phone: PropTypes.string,
    coordinates: PropTypes.shape({ lat: PropTypes.number.isRequired, lon: PropTypes.number.isRequired }),
  }).isRequired,
  apiKey: PropTypes.shape({ value: PropTypes.string.isRequired }).isRequired,
};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js